import React from 'react'
import classNames from 'classnames'
import { WhiteLabel, customerThemes } from '../../config/customerThemes'

type Props = {
  type?: WhiteLabel
  style?: React.CSSProperties
}

const Wordmark = ({ type = 'app', style }: Props) => {
  const logoType: WhiteLabel = type in customerThemes ? (type as WhiteLabel) : ('app' as WhiteLabel)

  const LogoComponent = customerThemes[logoType].wordmark

  if (LogoComponent === null || LogoComponent === undefined) {
    return null
  }

  if (typeof LogoComponent === 'function') {
    return LogoComponent()
  }

  return (
    <img
      src={customerThemes[logoType].wordmark as string}
      alt={logoType}
      className={classNames('wordmark', logoType)}
      style={{ ...customerThemes[logoType].wordmarkStyle, ...style }}
    />
  )
}

export default Wordmark
